import type { HighRiskMerchant as HighRiskMerchantType } from "features/ecommerce/types";
import { HighRiskMerchant } from "ui/forms/ECommerce";
import { useOnboardingStepData } from "ui/organizms/ECommerce/Onboarding/common";

export const useDirectorsAndShareholders = () => {
    const { data } = useOnboardingStepData<HighRiskMerchantType.OnboardingDirectorsAndShareholders>();

    const formProps: HighRiskMerchant.DirectorsAndShareholders.OnboardingDirectorsAndShareholdersForm = {
        bootstrapData: {},
        initialValues: HighRiskMerchant.DirectorsAndShareholders.getInitialValues(data),
        isBootstrapDataLoading: false,
        onSaveOrCreate: values => {
            console.log('DirectorsAndShareholders values to save:', values);
            alert('Not implemented yet please wait for the update.');
        }
    };

    return {
        ...formProps,
        ...HighRiskMerchant.DirectorsAndShareholders.useForm(formProps),
        ...data
    };
};

export default useDirectorsAndShareholders;
